import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { format } from 'date-fns';
import QRCode from "react-qr-code";
import AppContext from "../context/AppContext";
import CopyLogo from "../assets/svg/copy-logo.svg";
import BackgroundCopy from "../assets/svg/background-copy.svg"
import toast from "react-hot-toast";
import { formatDistanceToNow, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { Line } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';
import LanguageAndNotificacions from "../components/LanguageAndNotificacions";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export default function Copy() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loading, showCopy, updateLoading } = useContext(AppContext);
  const [listTRX, setListTRX] = useState([]);
  const [tokensAll, setTokensAll] = useState([]);
  const [dataCopy, setDataCopy] = useState([]);
  const [dataUser, setDataUser] = useState([]);
  const [estadisticas, setEstadisticas] = useState([]);
  const [tab, setTab] = useState("portfolio")
  const [wallet, setWallet] = useState();
  const [selectedSupply, setSelectedSupply] = useState(null);

  const data = {
    labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun'],
    datasets: [
      {
        label: "Balance",
        data: [1, 1, 1, 1, 1, 1], // Datos de la gráfica
        borderColor: 'rgb(255, 255, 255)', // Color amarillo para la línea
        backgroundColor: 'rgba(218, 0, 0, 0)', // Fondo transparente para la línea
        fill: {
          target: "origin", // 3. Set the fill options
          above: "rgba(201, 0, 215, 0.16)"
        },
        tension: 0.4, // Controla la curvatura de la línea
        pointBackgroundColor: 'rgb(255, 255, 255)', // Color de los puntos
        pointBorderColor: 'rgb(255, 255, 255)',
      },
    ],
  };

  // Opciones del gráfico
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
    elements: {
      line: {
        borderWidth: 2,
      },
    },
    // Fondo oscuro para el gráfico
    layout: {
      backgroundColor: 'rgb(0, 0, 0)',
    },
  };

  useEffect(() => {
    getWallet();
    getCopy();
  }, []);

  const getWallet = () => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/copy`, {
      method: "POST",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {

        if (!response.status) {
          if (response.redirect) {
            navigate("/");
          }
        } else {
          setWallet(response?.address);
        }
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  }


  const getCopy = () => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/copy`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {

        if (!response.status) {
          if (response.redirect) {
            navigate("/");
          }
          const data = response?.data
          if (parseInt(data?.active) === 1) {
            getAllTRX(data?.address)
            setDataUser(data)
            setSelectedSupply(data?.supply);
          } else {
            showCopy(true)
            updateLoading(false);
          }
        } else {
          updateLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  }


  const getAllTRX = (wallet_destinity) => {
    updateLoading(true);
    fetch(`https://d9hpgqeh88.execute-api.us-west-1.amazonaws.com/default/ctx-copy-info?wallet=${wallet_destinity}`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response?.wallet) {
          setDataCopy(response);
          setListTRX(response?.trades)
          setTokensAll(response?.tokens)
          const totalTransacciones = response.trades.length;
          // Sumar solUsed y solReceived
          const volumen = response.trades.reduce((total, trx) => {
            const sol = trx.solUsed || trx.solReceived || 0;
            return total + sol;
          }, 0);
          // Set para guardar nombres únicos de tokens
          const tokensUnicos = new Set();
          response.trades.forEach(trx => {
            if (trx.tokenName) {
              tokensUnicos.add(trx.tokenName);
            }
          });
          const totalTokensDiferentes = tokensUnicos.size;
          setEstadisticas({
            totalTransacciones,
            volumen,
            totalTokensDiferentes
          })
          updateLoading(false);
        }
        console.log(response)
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  }

  const handleSupplyClick = (value) => {
    if (value !== "10" && value !== "30") return; // Solo 2.5% (10) y 5% (30) son válidos
    const supplyMap = {
      "10": 2.5,
      "30": 5,
    };

    const supplyToSend = supplyMap[value];
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/update-copy`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ supply: supplyToSend }),
    })
      .then((response) => response.json())
      .then((response) => {
        updateLoading(false);
        if (!response.status) {
          toast.error(t("_AUTH._ERROR"));
        } else {
          getCopy();
          toast.success(t("_PROFILE._SUCCESS"));
        }
      })
      .catch((error) => {
        console.error(error);
        updateLoading(false);
      });
  };


  const handleSupplyWidhtawaral = () => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/withdrawal-copy`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ withdrawal_system: true }),
    })
      .then((response) => response.json())
      .then((response) => {
        updateLoading(false);
        if (!response.status) {
          toast.error(t("_AUTH._ERROR"));
        } else {
          getCopy();
          toast.success(t("_PROFILE._SUCCESS"));
        }
      })
      .catch((error) => {
        console.error(error);
        updateLoading(false);
      });
  };

  const copyWallet = () => {
    navigator.clipboard.writeText(
      `${wallet}`
    );
    toast.success(t("_FINANCE._COPYMESSAGE"));
  };


  const oraculo = (props) => {
    if (window.localStorage.getItem("tron")) {
      let value = props * window.localStorage.getItem("tron");
      let fomart = Number.parseFloat(value).toFixed(3);
      let valueFormat = formatNumber(fomart);
      return valueFormat;
    }
  };

  const oraculoinverso = (props) => {
    if (window.localStorage.getItem("tron")) {
      let value = props / window.localStorage.getItem("tron");
      let fomart = Number.parseFloat(value).toFixed(3);
      let valueFormat = formatNumber(fomart);
      return valueFormat;
    }
  };

  const formatNumber = (value) => {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    const valueString = value.toString();
    const [integerPart, decimalPart] = valueString.split('.');

    if (decimalPart && decimalPart.length > 2) {
      return `${integerPart}.${decimalPart.slice(0, 2)}`;
    }

    return valueString;
  };


  const formatTimestamp = (timestampInSeconds) => {
    if (!timestampInSeconds) return "-";

    try {
      const date = new Date(timestampInSeconds * 1000); // convertir a milisegundos
      return format(date, "yy/MM/dd HH:mm:ss");
    } catch (err) {
      console.error("Error formateando timestamp:", err);
      return "-";
    }
  }

  return (
    <>
      <div className="flex flex-col lg:flex-row lg:justify-between w-3/4 lg:w-full gap-3">
        <h1 className="text-white text-3xl"></h1>
        <LanguageAndNotificacions />
      </div>
      <div className="bg-black/90 p-4 rounded-lg bg-no-repeat" style={{ backgroundImage: `url(${BackgroundCopy})` }}>
        <div className="flex justify-center bg-white/40 p-2 rounded-lg lg:bg-transparent">
          <img src={CopyLogo} alt="CTFLIX" className="z-20" />
        </div>

        <div className="mx-auto p-2 lg:p-6 text-white">
          <div className="flex flex-col lg:flex-row justify-center gap-6">
            <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 w-full lg:w-1/2 ">
              <h2 className="text-3xl font-semibold mb-2 text-center">{t("_COPY._TITLE")}</h2>
              <p className="text-center text-md mb-4">{t("_FINANCE._QR")}</p>
              <div className="flex flex-col justify-center items-center w-full my-2">
                <QRCode
                  size={256}
                  fgColor={"#c900d7"}
                  level={"L"}
                  bgColor={"#ffffff00"}
                  value={"https://chat.whatsapp.com/I40EzQSOmeW6XBAD3NRkQC"}
                  className={"w-4/6 p-2 rounded-lg"}
                  viewBox={`0 0 256 256`}
                />
              </div>
              <div className="flex flex-row w-full mx-auto mt-4 bg-zinc-900 p-2 gap-2 text-white cursor-pointer rounded-lg justify-center items-center text-sm  border-zinc-600 border-2 " onClick={() => copyWallet()}>
                <p className="hidden lg:block">
                  {wallet ? wallet : "Loading"}
                </p>
                <p className="block lg:hidden">
                  {wallet ? wallet.slice(0, 4) + "......" + wallet.slice(-4) : "Loading"}
                </p>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z" />
                </svg>
              </div>
              <div className="text-sm gap-2 my-4">
                <h2 className="text-white">{t("_FINANCE._NETWORK")}: SOLANA</h2>
                <p className="text-white">{t("_FINANCE._INSTRUCTIONS")}</p>
                <ul className="text-sm text-white list-disc">
                  <li>{t("_FINANCE._STEP1")}</li>
                  <li className="text-red-600">{t("_FINANCE._STEP2")}</li>
                  <li className="text-red-600">{t("_COPY._MIN")}</li>
                </ul>
              </div>
            </div>
            <div className="flex flex-col w-full lg:w-1/2 gap-4">
              <div className="flex flex-col lg:flex-row gap-2 justify-center">
                <div className="bg-black/80 text-white rounded-lg w-full border-zinc-600 border-2 w-full lg:w-1/2 h-auto">
                  <h3 className="w-full p-2 px-4 bg-fuchsia-950/80">{t("_COPY._BALANCE")}</h3>
                  <Line data={data} options={options} />
                  <div className="group gap-2 flex flex-col p-4 justify-center items-center flex-end">

                    <div className="flex transition-opacity duration-300 opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                      <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-4/5 text-end">{dataCopy?.sol_balance || 0}</p>
                      <p className="w-1/5">SOL</p>
                    </div>
                    <div className="flex transition-opacity duration-300 opacity-100  flex-row  gap-2 text-white w-full  flex-end">
                      <p className="cursor-pointer bg-zinc-900 font-medium p-1 rounded  border-zinc-700 border-2 text-xs w-4/5 text-end">{dataUser?.balance || 0}</p>
                      <p className="w-1/5">{t("_DASHBOARD._TOTAL")}</p>
                    </div>
                  </div>
                </div>
                <div className="bg-black/80 text-white rounded-lg w-full border-zinc-600 border-2 w-full lg:w-1/2 h-auto">
                  <h3 className="w-full p-2 px-4 bg-fuchsia-950/80">{t("_COPY._ACTION")}</h3>
                  {dataUser.balance && (
                    <div className="flex flex-col gap-4 p-4 items-center justify-center">
                      {dataUser?.withdrawal_system === "1" ? (
                        <button
                          className="w-full h-14 bg-gray-800 text-white rounded-xl flex items-center justify-center cursor-not-allowed"
                          disabled
                        >
                          Withdrawal in progress
                        </button>
                      ) : (
                        <button
                          className="w-full h-14 bg-gray-800 hover:bg-fuchsia-600 text-white rounded-xl flex items-center justify-center"
                          onClick={() => handleSupplyWidhtawaral()}
                        >
                          {t("_COPY._CAPITAL")}
                        </button>
                      )}
                    </div>
                  )}
                </div>
                {/* 
                <div className="bg-black/80 text-white rounded-lg w-full border-zinc-600 border-2 w-full lg:w-1/2 h-auto">
                  <h3 className="w-full p-2 px-4 bg-fuchsia-950/80">{t("_COPY._TYPE")}</h3>
                  <div className="flex flex-col gap-4 p-4">
                    <div className="inline-flex items-center">
                      <label className="relative flex items-center cursor-pointer" for="basic">
                        <input
                          name="framework"
                          type="radio"
                          id="basic"
                          className="peer h-2 w-2 cursor-pointer appearance-none rounded-full border border-zinc-300 checked:border-slate-400 transition-all"
                          checked
                        />
                        <span className="absolute bg-fuchsia-600  w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
                      </label>
                      <label className="ml-2 text-slate-600 cursor-pointer text-sm" for="basic">
                        <div>
                          <p className="text-white">
                            {t("_COPY._TYPE")}
                          </p>
                          <p className="text-slate-500 text-xs">
                            {t("_COPY._CONSERVEDESCRIPTION")}
                          </p>
                        </div>
                      </label>
                    </div>
                    <div className="inline-flex items-center cursor-not-allowed">
                      <label className="relative flex items-center cursor-pointer" for="medium">
                        <input
                          name="framework"
                          type="radio"
                          className="peer h-2 w-2 cursor-not-allowed appearance-none rounded-full border border-zinc-300 checked:border-slate-400 transition-all"
                          id="medium"
                          disabled
                        />
                        <span className="absolute bg-fuchsia-600 w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
                      </label>
                      <label className="ml-2 text-slate-600 cursor-pointer text-sm" for="medium">
                        <div>
                          <p className="text-white">
                            {t("_COPY._MODERADE")}
                          </p>
                          <p className="text-slate-500 text-xs">
                            {t("_COPY._MODERADEDESCRIPTION")}
                          </p>
                        </div>
                      </label>
                    </div>
                    <div className="inline-flex items-center cursor-not-allowed">
                      <label className="relative flex items-center cursor-pointer" for="hard">
                        <input
                          name="framework"
                          type="radio"
                          className="peer h-2 w-2 cursor-not-allowed appearance-none rounded-full border border-zinc-300 checked:border-slate-400 transition-all"
                          id="hard"
                          disabled
                        />
                        <span className="absolute bg-fuchsia-600 w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
                      </label>
                      <label className="ml-2 text-slate-600 cursor-pointer text-sm" for="hard">
                        <div>
                          <p className="text-white">
                            {t("_COPY._ADVANCED")}
                          </p>
                          <p className="text-slate-500 text-xs">
                            {t("_COPY._ADVANCEDDESCRIPTION")}
                          </p>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                */}
              </div>
              <div className="flex flex-col lg:flex-row gap-2 justify-center">
                <div className="bg-black/80 text-white rounded-lg w-full border-zinc-600 border-2 lg:w-1/2 h-40">
                  <h3 className="w-full p-2 px-4 bg-fuchsia-950/80">{t("_COPY._SLIPPAGE")}</h3>
                  <div className="flex lg:space-x-4 p-4 justify-center items-center">
                    <label className="relative cursor-pointer">
                      <input type="radio" name="slippage" value="30" className="hidden peer" disabled />
                      <div className="w-14 h-14 bg-gray-400 text-gray-600 rounded-xl flex items-center justify-center cursor-not-allowed">
                        3%
                      </div>
                    </label>
                    <label className="relative cursor-pointer">
                      <input type="radio" name="slippage" value="1" className="hidden peer" disabled />
                      <div className="w-14 h-14 bg-gray-400 text-gray-600 rounded-xl flex items-center justify-center cursor-not-allowed">
                        5%
                      </div>
                    </label>
                    <label className="relative cursor-pointer">
                      <input type="radio" name="slippage" value="10" className="hidden peer" checked />
                      <div className="w-14 h-14 bg-gray-400 text-gray-600 rounded-xl flex items-center justify-center peer-checked:bg-fuchsia-600 peer-checked:text-white ">
                        10%
                      </div>
                    </label>
                    <label className="relative cursor-not-allowed">
                      <input type="radio" name="slippage" value="50" className="hidden peer" disabled />
                      <div className="w-14 h-14 bg-gray-400 text-gray-600 rounded-xl flex items-center justify-center cursor-not-allowed">
                        15%
                      </div>
                    </label>
                  </div>
                </div>
                <div className="bg-black/80 text-white rounded-lg w-full border-zinc-600 border-2 lg:w-1/2 h-40">
                  <h3 className="w-full p-2 px-4 bg-fuchsia-950/80">{t("_COPY._SUPPLY")}</h3>
                  <div className="flex lg:space-x-4 p-4 justify-center items-center">
                    <label className="relative cursor-not-allowed">
                      <input type="radio" name="supply" value="1" className="hidden peer" disabled />
                      <div className="w-14 h-14 bg-gray-400 text-gray-600 rounded-xl flex items-center justify-center cursor-not-allowed">
                        1%
                      </div>
                    </label>

                    <label className="relative cursor-pointer">
                      <input
                        type="radio"
                        name="supply"
                        value="10"
                        className="hidden peer"
                        checked={selectedSupply === "2.5"}
                        onChange={() => handleSupplyClick("10")}
                      />
                      <div
                        className={`w-14 h-14 rounded-xl flex items-center justify-center 
      ${selectedSupply === "2.5"
                            ? "bg-fuchsia-600 text-white"
                            : "bg-gray-400 text-gray-600"}`}
                        onClick={() => {
                          setSelectedSupply("2.5");
                          handleSupplyClick("10");
                        }}
                      >
                        2.5%
                      </div>
                    </label>

                    <label className="relative cursor-pointer">
                      <input
                        type="radio"
                        name="supply"
                        value="30"
                        className="hidden peer"
                        checked={selectedSupply === "5"}
                        onChange={() => handleSupplyClick("30")}
                      />
                      <div
                        className={`w-14 h-14 rounded-xl flex items-center justify-center 
      ${selectedSupply === "5"
                            ? "bg-fuchsia-600 text-white"
                            : "bg-gray-400 text-gray-600"}`}
                        onClick={() => {
                          setSelectedSupply("5");
                          handleSupplyClick("30");
                        }}
                      >
                        5%
                      </div>
                    </label>


                    <label className="relative cursor-not-allowed">
                      <input type="radio" name="supply" value="50" className="hidden peer" disabled />
                      <div className="w-14 h-14 bg-gray-400 text-gray-600 rounded-xl flex items-center justify-center cursor-not-allowed">
                        10%
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex flex-col lg:flex-row gap-2 justify-center">
                <div className="bg-black/80 text-white rounded-lg w-full border-zinc-600 border-2 lg:w-1/2 h-40">
                  <h3 className="w-full p-2 px-4 bg-fuchsia-950/80">{t("_DASHBOARD._STATUS")}</h3>
                  <div className="flex flex-row gap-10 p-4 justify-between mx-4">
                    <div className="flex flex-col gap-4">
                      <p>{t("_DASHBOARD._STATUS")}</p>
                      <p>{t("_COPY._CONNECTION")}</p>
                    </div>
                    <div className="flex flex-col gap-4">
                      <p> {dataUser?.active === "1" ? t("_DASHBOARD._STATUS_ACTIVE") : t("_DASHBOARD._STATUS_INACTIVE")}</p>
                      <p> {dataUser?.configure === "1" ? t("_DASHBOARD._STATUS_ACTIVE") : t("_DASHBOARD._STATUS_INACTIVE")}</p>
                    </div>
                  </div>
                </div>
                <div className="bg-black/80 text-white rounded-lg w-full border-zinc-600 border-2 lg:w-1/2 h-40">
                  <h3 className="w-full p-2 px-4 bg-fuchsia-950/80">{t("_COPY._STATISTICS")}</h3>
                  <div className="flex gap-4 p-4 justify-center items-center h-auto">
                    <div className="flex items-center justify-center w-20 h-12 bg-gray-800 text-white rounded-lg text-xs flex-col gap-2">
                      <span>TXNS</span>
                      <span >{estadisticas?.totalTransacciones || 0} </span>
                    </div>
                    <div className="flex items-center justify-center w-20 h-12 bg-gray-800 text-white rounded-lg text-xs flex-col gap-2">
                      <span>Volumen</span>
                      <span >{formatNumber(estadisticas?.volumen || 0)} SOL</span>
                    </div>
                    <div className="flex items-center justify-center w-20 h-12 bg-gray-800 text-white rounded-lg text-xs flex-col gap-2">
                      <span>Tokens</span>
                      <span>{estadisticas?.totalTokensDiferentes || 0} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-black/60 text-white lg:p-8 p-4 rounded-lg w-full border-zinc-600 border-2 my-8">
            <div className="flex flex-row gap-4 my-2">
              <button className={`lg:w-1/4 w-full h-14 text-white rounded-xl flex items-center justify-center hover:bg-fuchsia-600 peer-checked:text-white ${tab === "portfolio" ? "bg-fuchsia-600" : "bg-gray-800 "}`} onClick={() => setTab("portfolio")}>{t("_COPY._PORTFOLIO")} </button>
              <button className={`lg:w-1/4  w-full h-14 text-white rounded-xl flex items-center justify-center hover:bg-fuchsia-600 peer-checked:text-white ${tab === "trx" ? "bg-fuchsia-600" : "bg-gray-800 "}`} onClick={() => setTab("trx")}>Transacciones </button>
            </div>
            <div className="relative overflow-x-auto w-full">
              {tab === "trx" ?
                <>
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg ">
                    <thead className="text-md text-white border-b-2">
                      <tr className="bg-black/60 text-fuchsia-600 lg:text-2xl uppercase">
                        <th className="px-6 py-4">Date</th>
                        <th className="px-6 py-4">Token</th>
                        <th className="px-6 py-4">Type</th>
                        <th className="px-6 py-4">Solana</th>
                        <th className="px-6 py-4">USD</th>
                        <th className="px-6 py-4 "> Amount</th>
                        <th className="px-6 py-4 ">ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listTRX.map((item, index) => (
                        <tr className="border-b border-gray-700">
                          <td className="px-6 py-4">{formatTimestamp(item?.timestamp)}</td>
                          <td className="px-6 py-4 text-gray-400 flex gap-4">
                            <img className="h-auto w-6 mr-2" src={item?.tokenImage || CopyLogo} alt={item?.tokenName || "CTX"} />
                            {item?.tokenSymbol}
                          </td>
                          <td className={`px-6 py-4 ${item?.type === "sell" ? "text-red-400" : "text-green-400"} uppercase`}>{item?.type}</td>
                          <td className={`${item?.type === "sell" ? "text-green-400" : "text-red-400"}  px-6 py-4 `} > {item?.solUsed ? "-" : "+"} {item?.solUsed ? item?.solUsed : item?.solReceived} SOL</td>
                          <td className={`${item?.type === "sell" ? "text-green-400" : "text-red-400"}  px-6 py-4 `} > {item?.solUsed ? "-" : "+"} {item?.solUsed ? oraculo(item?.solUsed) : oraculo(item?.solReceived)} USD</td>
                          <td className="px-6 py-4">{item?.tokenAmount} <br />  {item?.tokenSymbol}</td>
                          <td className="px-6 py-4">
                            <a href={"https://solscan.io/tx/" + item?.signature} target={"_blank"} rel="noreferrer">
                              <button className="text-white px-3 py-1 rounded">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
                                </svg>
                              </button>
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
                :
                <>
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-lg ">
                    <thead className="text-md text-white border-b-2">
                      <tr className="bg-black/60 text-fuchsia-600 lg:text-2xl uppercase">
                        <th className="px-6 py-4">Token</th>
                        <th className="px-6 py-4">Solana</th>
                        <th className="px-6 py-4">USD</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tokensAll.map((item, index) => (
                        <tr className="border-b border-gray-700">
                          <td className="px-6 py-4 text-gray-400 flex gap-4">
                            <img className="h-auto w-6 mr-2" src={item?.image_url || CopyLogo} alt={item?.name || "CTX"} />
                            {item?.symbol}
                          </td>
                          <td className="px-6 py-4">{formatNumber(item?.total_value_in_sol || 0)} -  SOL</td>
                          <td className="px-6 py-4">{formatNumber(item?.total_value_usd || 0)}   -  {item?.currency}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>}

            </div>
          </div>

        </div>
      </div>
    </>
  );
}
